import styled from "styled-components"

export default {
    "Wrapper": styled.div`
        display: flex;
        flex-direction: column;
        align-items: center;
        padding: 54px 28px;
        gap: 36px;
    `,

    "List": styled.div`
        display: flex;
        flex-direction: column;
        gap: 16px;
    `,
    "Element": styled.div`
        display: flex;
        gap: 16px;
        cursor: pointer;

        & > img {
            width: 120px;
            min-width: 120px;
            height: 72px;
            object-fit: cover;
            object-position: center center;
            border-radius: 4px;
        }

        & > div {
            display: flex;
            flex-direction: column;
            gap: 8px;

            & > h2 {
                width: 100%;
                overflow: hidden;
                text-overflow: ellipsis;
                display: -webkit-box;
                -webkit-line-clamp: 2;
                -webkit-box-orient: vertical;
                ${({ theme }) => theme.font["medium-medium"]};
            }

            & > p {
                ${({ theme }) => theme.font["tiny-regular"]};
                color: ${({ theme }) => theme.color["grey3"]};
            }
        }
    `,

    "Option": styled.p`
        ${({ theme }) => theme.font["xsmall-medium"]};
    `,
}